export default [
  { label: 'signup.number_of_employees.size1', value: '2-5' },
  { label: 'signup.number_of_employees.size2', value: '6-10' },
  { label: 'signup.number_of_employees.size3', value: '11-20' },
  { label: 'signup.number_of_employees.size4', value: '21-50' },
  { label: 'signup.number_of_employees.size5', value: '51-100' },
  { label: 'signup.number_of_employees.size6', value: '101-200' },
  { label: 'signup.number_of_employees.size7', value: '> 200' },
];
